<header id="page-topbar" style="padding: 0px calc(250px / 2);">
    <div class="navbar-header">
        <div class="d-flex">
            <div class="navbar-brand-boxes" style="width: auto !important;">
                <a routerLink="/" class="logo logo-dark">
                    <span class="logo-lg">
                        <img class="image-responsive" src="assets/images/navbar_logo.svg" alt=""
                            height="20">
                            
                    </span>
                    <h6 class="m-2"> Help Desk</h6>
                </a>
            </div>
        </div>

        <div class="d-flex">
            <div class="dropdown d-none d-lg-inline-block">
                <button type="button" class="btn header-item noti-icon p-1" data-toggle="fullscreen" title="View Fullscreen" (click)="fullscreen()">
                    <i class="bx bx-fullscreen"></i>
                </button>
            </div>


            <div class="dropdown d-inline-block" ngbDropdown>
                <button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown"
                    (click)="getNotification()" ngbDropdownToggle>
                    <i class="bx bx-bell bx-tada"></i>
                    <span class="badge bg-danger rounded-pill fnt-wt-400">{{count}}</span>
                </button>

                <div *ngIf='notificationFlag' class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                    aria-labelledby="page-header-notifications-dropdown" ngbDropdownMenu>
                    <div class="p-3">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="m-0">Notifications</h6>
                            </div>
                            <div class="col-auto">
                                <a href="javascript: void(0);" class="small" (click)="getAllNotification()">View All</a>
                            </div>
                            <div class="col-auto">
                                <a href="javascript: void(0);" class="small" (click)="clearNotification()">Clear All</a>
                            </div>
                        </div>
                    </div>
                    <ngx-simplebar style="position: relative; height: 270px;">
                        <a href="javascript: void(0);" class="text-reset notification-item" *ngIf="message;">
                            <div class="media">
                                <div class="avatar-xs me-3">
                                    <span class="avatar-title bg-primary rounded-circle font-size-16">
                                        <i class="bx bx-badge-check"></i>
                                    </span>
                                </div>
                                <div class="media-body">
                                    <h6 class="mt-0 mb-1">{{ message.notification.title }}</h6>
                                    <div class="font-size-12 text-muted">
                                        <p class="mb-1">{{ message.notification.body }}</p>
                                    </div>
                                </div>
                            </div>
                        </a>

                        <a href="javascript: void(0);" class="text-reset notification-item"
                            *ngFor="let item of notificationData">
                            <div class="media">
                                <div class="avatar-xs me-3">
                                    <span class="avatar-title bg-primary rounded-circle font-size-16">
                                        <i class="bx bx-badge-check"></i>
                                    </span>
                                </div>
                                <div class="media-body">
                                    <h6 class="mt-0 mb-1">{{item.title}}</h6>
                                    <div class="font-size-12 text-muted">
                                        <p class="mb-1">{{item.message}}</p>
                                        <p class="mb-0"><i class="mdi mdi-clock-outline"></i>{{item.createdAt}}</p>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </ngx-simplebar>
                </div>
            </div>

            
            <!-- <div class="dropdown d-inline-block" ngbDropdown>
                <button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown"
                    (click)="getNotification()" ngbDropdownToggle>
                    <i class="bx bx-bell bx-tada"></i>
                    <span class="badge bg-danger rounded-pill fnt-wt-400">{{totalElement.length}}</span>
                </button>

                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                    aria-labelledby="page-header-notifications-dropdown" ngbDropdownMenu>
                    <div class="p-3">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="m-0">Notifications</h6>
                            </div>
                            <div class="col-auto">
                                <a href="javascript: void(0);" class="small" (click)="getAllNotification()">View All</a>
                            </div>
                        </div>
                    </div>
                    <ngx-simplebar style="position: relative; height: 300px;">
                        <a href="javascript: void(0);" class="text-reset notification-item" *ngIf="message;">
                            <div class="media">
                                <div class="avatar-xs me-3">
                                    <span class="avatar-title bg-primary rounded-circle font-size-16">
                                        <i class="bx bx-badge-check"></i>
                                    </span>
                                </div>
                                <div class="media-body">
                                    <h6 class="mt-0 mb-1">{{ message.notification.title }}</h6>
                                    <div class="font-size-12 text-muted">
                                        <p class="mb-1">{{ message.notification.body }}</p>
                                    </div>
                                </div>
                            </div>
                        </a>

                        <a href="javascript: void(0);" class="text-reset notification-item"
                            *ngFor="let item of notificationData">
                            <div class="media">
                                <div class="avatar-xs me-3">
                                    <span class="avatar-title bg-primary rounded-circle font-size-16">
                                        <i class="bx bx-badge-check"></i>
                                    </span>
                                </div>
                                <div class="media-body">
                                    <h6 class="mt-0 mb-1">{{item.title}}</h6>
                                    <div class="font-size-12 text-muted">
                                        <p class="mb-1">{{item.message}}</p>
                                        <p class="mb-0"><i class="mdi mdi-clock-outline"></i>{{item.createdAt}}</p>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </ngx-simplebar> -->
                    <!-- <div class="p-2 border-top d-grid">
                        <a class="btn btn-sm btn-link font-size-14 text-center" href="javascript:void(0)">
                            <i class="mdi mdi-arrow-right-circle me-1"></i> <span key="t-view-more">View More..</span>
                        </a>
                    </div> -->
                <!-- </div>
            </div> -->

            <div class="dropdown d-inline-block" ngbDropdown>
                <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
                    <img class="rounded-circle header-profile-user" *ngIf="userUrl !=''" [src]="transform()" />
                    <span class="d-none d-xl-inline-block ms-1"><small>{{firstNameDisplayOnTop}}</small></span>
                    <em class="mdi mdi-chevron-down d-none d-xl-inline-block"></em>
                </button>

                <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                    <!-- <a class="dropdown-item" href="javascript: void(0);" (click)="myProfile()"><em
                            class="bx bx-user font-size-16 align-middle me-1"></em>
                        Profile</a> -->
                    <a class="dropdown-item" href="javascript: void(0);" (click)="changePassword()"><em
                            class="bx bx-wallet font-size-16 align-middle me-1"></em>Change
                        Password</a>

                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item text-danger" href="javascript:
                        void(0);" (click)="logout()"><em class="bx bx-power-off font-size-16 align-middle
                            me-1 text-danger"></em>
                        Logout</a>
                </div>
            </div>
        </div>
    </div>
</header>

<div class="topnav">
    <div class="container-fluid">
        <nav class="navbar navbar-light navbar-expand-lg topnav-menu active">
            <div class="collapse navbar-collapse active" id="topnav-menu-content">
                <ul class="navbar-nav">
                    <ng-container *ngFor="let item of menuItems">
                        <li class="nav-item ms-5" *ngIf="item.permission">
                            <a class="nav-link font-size-15" href="javascript: void(0);" id="topnav-components"
                                (click)="onClick(item)" [routerLink]="item.link" [routerLinkActive]="['active']"
                                role="button">
                                <i *ngIf="item.icon" class="bx {{item.icon}} me-2"></i>
                                {{ item.label }}
                            </a>
                        </li>
                    </ng-container>
                </ul>
            </div>
        </nav>
    </div>
</div>